import { render, staticRenderFns } from "./OBUState.vue?vue&type=template&id=468f8d0d&"
import script from "./OBUState.vue?vue&type=script&lang=js&"
export * from "./OBUState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports